import { createRouter, createWebHistory } from 'vue-router'
import HomePage from "../views/HomePage/HomePage.vue";
import LoginPage from "../views/Login/LoginPage.vue";
import RegisterPage from "../views/Login/RegisterPage.vue";
import InformationPage from "../views/Login/InformationPage.vue";
import IndexPage from "../views/IndexPage.vue";
import DevicePage from "../views/IndexPage/MyDevice.vue";
import TaskPage from "../views/IndexPage/TaskPage.vue";
import SoftwarePage from "../views/IndexPage/SoftwarePage.vue";
import DeviceInfo from "../views/IndexPage/DeviceInfo.vue";
import DeviceInfoWs from "../views/IndexPage/DeviceInfo_ws.vue";
import BodorPlus from "../views/IndexPage/SoftwarePage/BodorPlus.vue";
import BodorNext from "../views/IndexPage/SoftwarePage/BodorNext.vue";
import BodorNextNav from "../views/IndexPage/SoftwarePage/BodorNextNav.vue";
import BodorNestTubeNav from "../views/IndexPage/SoftwarePage/BodorNestTubeNav.vue";
import BodorNextTube from "../views/IndexPage/SoftwarePage/BodorNextTube.vue";
import NestDown10 from "../views/IndexPage/SoftwarePage/BodorNest10.vue";
import BodorNext15 from "../views/IndexPage/SoftwarePage/BodorNext15.vue";
import UserCenter from "../views/UserCenter.vue";
import CamPage from "../views/IndexPage/CamPage.vue";
import KnowledgeBase from "../views/IndexPage/KnowledgeBase.vue";
import FolderPage from "../views/IndexPage/KnowledgePage/FolderPage.vue";
import ArticlePage from "../views/IndexPage/KnowledgePage/ArticlePage.vue";
import TestPage from "../views/TestPage.vue";
import UsingKnowledge from "../views/IndexPage/UsingKnowledge.vue";
import RandomFile from "../views/IndexPage/UsingKnowledge/RandomFile.vue";
import VisitorPage from "../views/VisitorPage.vue";
import RepairPage from "../views/IndexPage/RepairPage.vue";
import SelfService from "../views/IndexPage/RepairReport/SelfService.vue";
import SelfService2 from "../views/IndexPage/RepairReport/SelfService2.vue";
import SummaryWeb from "../views/IndexPage/RepairReport/SummaryWeb.vue";
import StockWeb from "../views/IndexPage/RepairReport/StockWeb.vue";
import MaintainWeb from "../views/IndexPage/RepairReport/Maintain.vue";
import SelfArticle from "../views/IndexPage/RepairReport/SelfArticle.vue";
import OneClick from "../views/IndexPage/RepairReport/OneClick.vue";
import InternalService from "../views/InternalService.vue";
import CamReport from "../views/CamReport.vue";
import UserReport from "../views/UserReport.vue";
import NestVideo from "../views/IndexPage/SoftwarePage/NestVideo.vue";
import Maintenance from "../views/IndexPage/MaintenancePage.vue";
import ServicePolicy from "../views/IndexPage/ServicePage/ServicePolicy.vue";
import ServiceStandards from "../views/IndexPage/ServicePage/ServiceStandards.vue";
import DownloadCenter from "../views/IndexPage/DownloadCenter.vue";
import DownloadCenter2 from "../views/IndexPage/DownloadCenter2.vue";
import SoftwareDown from "../views/IndexPage/UsingKnowledge/SoftwareDown.vue";
import OperationGuide from "../views/IndexPage/UsingKnowledge/OperationGuide.vue";
import GuideArticle from "../views/IndexPage/UsingKnowledge/GuideArticle.vue";
import DownloadResource from "../views/IndexPage/KnowledgePage/DownloadResource.vue";
import FileUpload from "../views/IndexPage/FileUpload.vue";
import BodorGptPage from "../views/IndexPage/BodorGptPage.vue"; 

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/Login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/Register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path:'/Information',
    name:'Information',
    component:InformationPage
  },
  {
    path: '/index',
    name: 'index',
    component: IndexPage,
    children: [
      {
        path: 'device',
        name: 'device',
        component: DevicePage
      },
      {
        path: 'task',
        name: 'task',
        component: TaskPage
      },
      {
        path: 'software',
        name: 'software',
        component: SoftwarePage
      },
      {
        path: 'cam',
        name: 'cam',
        component: CamPage
      },
      {
        path: 'knowledge',
        name: 'knowledge',
        component: KnowledgeBase,
      },
      {
        path: 'use',
        name: 'use',
        component: UsingKnowledge,
      },
      {
        path: 'repair',
        name: 'repair',
        component: RepairPage,
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: Maintenance,
      },
      {
        path: 'file',
        name: 'file',
        component: FileUpload
      },
      {
        path: 'bodorGpt',
        name: 'bodorGpt',
        component: BodorGptPage
      }
    ]
  },
  {
    path: '/visitor',
    name: 'visitor',
    component: VisitorPage,
    children: [
      {
        path: 'software',
        name: 'visitorSoftware',
        component: SoftwarePage
      },
      {
        path: 'knowledge',
        name: 'visitorKnowledge',
        component: KnowledgeBase,
      },
      {
        path: 'download',
        name: 'download',
        component: DownloadCenter,
      }
    ]
  },
  {
    path: '/folder/:id',
    name: 'folder',
    component: FolderPage,
  },
  {
    path: '/article/:id/:parentId',
    name: 'article',
    component: ArticlePage,
  },
  {
    path: '/download2',
    name: 'download2',
    component: DownloadCenter2,
  },
  {
    path: '/guide',
    name: 'guide',
    component: OperationGuide,
  },
  {
    path: '/guideArticle/:id/:parentId',
    name: 'guideArticle',
    component: GuideArticle,
  },
  {
    path: '/selfArticle/:id/:parentId',
    name: 'selfArticle',
    component: SelfArticle,
  },
  {
    path: '/softwareDown/:id/:parentId/:isVisitor',
    name: 'softwareDown',
    component: SoftwareDown,
  },
  {
    path: '/deviceInfo/:orderNumber/:type',  // 指定设备信息的路径和名称  
    name: 'deviceInfo',
    component: DeviceInfo,
    props: true
  },
  {
    path: '/deviceInfoWs/:orderNumber/:type',  // 指定设备信息的路径和名称  
    name: 'deviceInfoWs',
    component: DeviceInfoWs,
    props: true
  },
  {
    path: '/bodorplus/:isVisitor',
    name: 'bodorplus',
    component: BodorPlus
  },
  {
    path:'/bodornextnav/:isVisitor',
    name:'bodornextnav',
    component:BodorNextNav
  },
  {
    path:'/bodornesttubenav/:isVisitor',
    name:'bodornesttubenav',
    component:BodorNestTubeNav
  },
  {
    path: '/bodornest/:isVisitor',
    name: 'bodornest',
    component: BodorNext
  },
  {
    path: '/bodornesttube/:isVisitor',
    name: 'bodornesttube',
    component: BodorNextTube
  },
  {
    path: '/nestdown1.0/:isVisitor',
    name: 'nestdown1.0',
    component: NestDown10
  },
  {
    path: '/bodornest1.5/:isVisitor',
    name: 'bodornest1.5',
    component: BodorNext15
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    component: UserCenter
  },
  {
    path: '/random',
    name: 'random',
    component: RandomFile
  },
  {
    path: '/self',
    name: 'self',
    component: SelfService2,
  },
  {
	 path:'/Summary',
	  name:'Summary',
	  component:SummaryWeb
  },
  {
    path:'/Stock',
     name:'Stock',
     component:StockWeb
   },
  {
    path:'/maintain',
    name:'maintain',
    component:MaintainWeb
  },
  {
    path: '/click',
    name: 'click',
    component: OneClick,
  },
  {
    path: '/test',
    name: 'test',
    component: TestPage
  },
  {
    path: '/service',
    name: 'service',
    component: InternalService,
  },
  {
    path: '/camReport',
    name: 'camReport',
    component: CamReport,
  },
  {
    path: '/userReport',
    name: 'userReport',
    component: UserReport,
  },
  {
    path: '/nestvideo',
    name: 'nestvideo',
    component: NestVideo
  },
  {
    path: '/standards',
    name: 'standards',
    component: ServiceStandards
  },
  {
    path: '/policy',
    name: 'policy',
    component: ServicePolicy
  },
  {
    path: '/dr',
    name: 'dr',
    component: DownloadResource
  }
];

const router = createRouter({
  history: createWebHistory(),
  base: '/app/',
  routes
})


let whiteList = ["/Login", "/", "/Register", "/visitor", "/visitor/software", "/visitor/knowledge", "/visitor/download", "/softwareDown", "/bodorplus", "/bodornextnav", "/bodornesttubenav", "/bodornest", "/bodornesttube", "/folder", "/article", "/service", "/camReport", "/nestvideo", "/bodornest1.5","/nestdown1.0","/Information", "/dr"];
router.beforeEach((to, from) => {
  //读取token
  let token = localStorage.getItem("token");
  let result = to.path.split('/', 2).join('/');
  //未登录
  if (!token) {
    if (whiteList.indexOf(result) == -1) {
      return { path: "/Login" };
    }
  } else {
    if (to.path == "/Login") {
      return { path: "/" };
    }
  }
});

export default router